var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTGiftcards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8335 8.40625H13.1668",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1668 6.85385V11.6205C13.1468 13.5205 12.6268 14.0005 10.6468 14.0005H4.35352C2.34018 14.0005 1.8335 13.5005 1.8335 11.5139V6.85385C1.8335 5.05385 2.2535 4.47385 3.8335 4.38052C3.9935 4.37385 4.16685 4.36719 4.35352 4.36719H10.6468C12.6601 4.36719 13.1668 4.86719 13.1668 6.85385Z",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1668 4.48667V9.14667C15.1668 10.9467 14.7468 11.5267 13.1668 11.62V6.85333C13.1668 4.86667 12.6601 4.36667 10.6468 4.36667H4.35352C4.16685 4.36667 3.9935 4.37333 3.8335 4.38C3.8535 2.48 4.37352 2 6.35352 2H12.6468C14.6601 2 15.1668 2.5 15.1668 4.48667Z",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.873H5.14665",
    stroke: "#121212",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57324 11.873H8.86658",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTGiftcards);
export default __webpack_public_path__ + "static/media/t_giftcards.2d3ee5cbc7d8b318364df5de2632cf4b.svg";
export { ForwardRef as ReactComponent };